import React from 'react';
import {
    Avatar, 
    AvatarBadge, 
    Box,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Text,
    Divider,
    Flex
  } from '@chakra-ui/react';

type Props = {
    fullName?: string;
    email?: string;
    role?: string
}

export default function HeaderAvatar({ fullName, email, role = 'Admin' }: Props) {
    return (
        <Menu>
            <MenuButton> 
                <Flex alignItems={'center'}>
                    <Avatar className='pointer' name={fullName} src='' size='sm' showBorder>
                        <AvatarBadge 
                            bg='green.500' 
                        />
                    </Avatar>
                    <Box marginLeft={'1'}>
                        <Text fontSize='xs' lineHeight={'10px'} fontWeight='semibold'>Keth Sons</Text>
                        <Text fontSize='xs' color='gray.500'>{role!}</Text>
                    </Box>
                </Flex>
            </MenuButton>
            <MenuList>
                <MenuItem>
                    <Box>
                        <Text fontSize='sm'>{fullName!}</Text>
                        <Text fontSize='sm' color='gray.500'>{email!}</Text>
                    </Box>
                </MenuItem>
                <Divider />
                <MenuItem fontSize='sm'>Go to app</MenuItem>
                <MenuItem fontSize='sm'>Go to app</MenuItem>
                <Divider />
                <MenuItem fontSize='sm'>Logout</MenuItem>
            </MenuList>
        </Menu>
    )
}